import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import ExcelQueryvalidation from "./ExcelQueryvalidation";
import { getFileStatus } from "../../utils/fileStatus";

interface AllProps {
  reports: any[];
  getBranch: any;
  redirectToDashboard?: any;
}

export default class QueryvalidationReporttable extends Component<AllProps> {
  render() {
    const { reports = [], redirectToDashboard = () => {} } = this.props;

    const columns = [
      {
        header: "S.no",
        key: "serial",
        td: (item: any) => (
          <span onClick={() => redirectToDashboard(item.id)}>
            {item.serial}
          </span>
        ),
      },
      {
        header: "File Name",
        key: "file_no",
        td: (item: any) => (
          <span onClick={() => redirectToDashboard(item.id)}>
            {item.file_no}
          </span>
        ),
      },
      {
        header: "File Picked By",
        key: "picked_by",
        td: (item: any) => (
          <span onClick={() => redirectToDashboard(item.id)}>
            {item.picked_by}
          </span>
        ),
      },
      {
        header: "File Status",
        key: "file_status",
        td: (item: any) => (
          <div onClick={() => redirectToDashboard(item.id)}>
            {getFileStatus(item.file_status)}
          </div>
        ),
      },
      {
        header: "Update Date",
        key: "updated_dt",
        td: (item: any) => (
          <span onClick={() => redirectToDashboard(item.id)}>
            {item.updated_dt}
          </span>
        ),
      },
      {
        header: "Login Date",
        key: "created_dt",
        td: (item: any) => (
          <span onClick={() => redirectToDashboard(item.id)}>
            {item.created_dt}
          </span>
        ),
      },
    ];

    // Map the reports to include ALL fields needed for Excel export
    const processedData = reports.map((report: any, index) => ({
      // Keep all original report data
      ...report,
      // Add serial number
      serial: index + 1,
      id: report.id,

      // Ensure document_list is properly structured if needed
      document_list: report.document_list || [],

      // Add any calculated fields if needed
      waiting_time: calculateTimeDifference(
        report.arrived_dt,
        report.picked_dt,
      ),
      working_time: calculateTimeDifference(
        report.picked_dt,
        report.completed_dt,
      ),
    }));

    return (
      <div className="">
        <div className="row">
          <div className="col-xl-12 col-md-12 p-3">
            {/* Pass the full processedData to Excel component */}
            {processedData && processedData.length > 0 && (
              <ExcelQueryvalidation data={processedData} />
            )}
          </div>
        </div>
        <ReactFlexyTable
          className="assigned-table"
          data={processedData}
          columns={columns}
          sortable
          pageSize={10}
          globalSearch
        />
      </div>
    );
  }
}

// Helper function to calculate time difference
const calculateTimeDifference = (
  startDate: string,
  endDate: string,
): string => {
  if (!startDate || !endDate) return "";
  try {
    const parseDate = (dateStr: string) => {
      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split("-");
      return new Date(`${year}-${month}-${day}T${timePart || "00:00:00"}`);
    };
    const start = parseDate(startDate);
    const end = parseDate(endDate);
    const diffMs = end.getTime() - start.getTime();
    if (diffMs < 0) return "";
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  } catch (error) {
    console.error("Error calculating time difference:", error);
    return "";
  }
};
